import { useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { configurePinnedPdfWorker } from '../utils/pinnedPdfWorker';

const usePinnedPdfWorker = () => {
  const [state, setState] = useState({ ready: false, error: null });

  useEffect(() => {
    try {
      configurePinnedPdfWorker(pdfjs);
      setState({ ready: true, error: null });
    } catch (_error) {
      setState({
        ready: false,
        error: '安全なPDF表示環境を確認できません。',
      });
    }
  }, []);

  return state;
};

export default usePinnedPdfWorker;
